// import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { getCurrentSite } from '../../utilities/site';

const useIsJA = () => {
  const intl = useIntl();
  const currentSite = getCurrentSite(intl.locale);
  const isJA = currentSite === 'jp';

  return isJA;
};

export default useIsJA;
